import React, { Component } from "react";
import Navbar from "../../components/newNavBar";
import Loader from "../../utils/loader";
import less from "./kyc.module.scss";
import AadharOtpModal from "../../components/AadharOtpModal";
import { message, Modal } from "antd";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { Fetch } from "../../utils/fetch";
import jwt from "../../utils/jwt";
import moment from "moment";

class kycCabOperator extends Component {
  state = {
    loading: true,
    showVerificationSuccessModal: false,
    showNameMismatchModal: false,
    showVerificationFailedModal: false,
    fileName: "No file chosen",
  };

  async componentDidMount() {
    try {
      const stateObj = { loading: false };
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      const userMobileNo = decodedToken.mobileNo;

      await this.fetchProfileDetails(userMobileNo);

      stateObj.loading = false;
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      this.setState(stateObj);
    } catch (err) {
      console.log(err);
    }
  }

  fetchProfileDetails = async (userMobileNo) => {
    const url = `/cabOperator/details?mobileNo=${userMobileNo}`;
    const options = {
      method: "get",
    };
    const stateObj = { loading: false };

    const response = await Fetch(url, options);
    if (response) {
      const userDetails = response[0];
      const bankDetails = userDetails.bankDetails || {};
      const isRcm = userDetails.isRcm;
      if (isRcm) {
        stateObj.isGSTINRequired = false;

        stateObj.aadhar =
          userDetails.kyc && userDetails.kyc.aadharVerifiedOn
            ? {
                maskedAadharNumber: userDetails.kyc.aadharUid,
                verifiedOn: userDetails.kyc.aadharVerifiedOn,
              }
            : "";

        stateObj.pan =
          userDetails.kyc && userDetails.kyc.panVerifiedOn
            ? {
                maskedPanNumber: userDetails.kyc.maskedPanNumber,
                verifiedOn: userDetails.kyc.panVerifiedOn,
              }
            : "";
      } else {
        stateObj.isGSTINRequired = true;
        stateObj.pan =
          userDetails.kyc && userDetails.kyc.panVerifiedOn
            ? {
                maskedPanNumber: userDetails.kyc.maskedPanNumber,
                verifiedOn: userDetails.kyc.panVerifiedOn,
              }
            : "";

        stateObj.gst =
          userDetails.kyc && userDetails.kyc.gstDetails
            ? userDetails.kyc.gstDetails
            : "";
      }
      if (bankDetails.status === "ARCHIVED") {
        stateObj.cancelledChequeDetails = "PENDING";
      } else {
        stateObj.cancelledChequeDetails = bankDetails.status || "PENDING";
      }

      stateObj.cancelledChequeDetails === "APPROVED"
        ? (stateObj.fileName = "File Uploaded")
        : (stateObj.fileName = "No file chosen");
      this.setState(stateObj);
      return;
    } else {
      message.error("no data found");
      return;
    }
  };

  handleChange = (field, value) => {
    this.setState((prevState) => {
      const errors = { ...prevState.errors };
      errors[field] = "";

      return {
        [field]: value,
        errors,
      };
    });
  };

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  verifyGST = async () => {
    this.setState({ verificationGSTLoader: true });
    const { gst } = this.state;
    if (!gst || typeof gst === "object") {
      message.error("Please enter GST to verify");
      this.setState({
        verificationGSTLoader: false,
      });
      return;
    }

    const payload = { gst };
    const options = { method: "post", data: payload };
    const url = "/cabOperator/kycVerify";
    const response = await Fetch(url, options);

    if (response.decentroResponseKey === "NAME_MISMATCHED") {
      this.setState({ showNameMismatchModal: true });
    } else if (!response.verified) {
      this.setState({
        showVerificationFailedModal: true,
        errorMessage: response.message,
        verificationGSTLoader: false,
      });
    } else {
      this.setState({
        gst: { number: gst, verifiedOn: new Date() },
        showVerificationSuccessModal: true,
        kycOf: "GSTIN",
        verificationGSTLoader: false,
      });
    }
  };

  maskPan = (pan) => {
    if (!pan || pan.length !== 10) return pan;

    const firstThree = pan.slice(0, 3);
    const lastThree = pan.slice(-3);

    return `${firstThree}XXXX${lastThree}`;
  };

  verifyPAN = async () => {
    this.setState({ verificationPANLoader: true });
    const { pan } = this.state;
    if (!pan || typeof pan === "object") {
      message.error("Please enter PAN to verify");
      this.setState({
        verificationPANLoader: false,
      });
      return;
    }

    const payload = { pan };
    const options = { method: "post", data: payload };
    const url = "/cabOperator/kycVerify";
    const response = await Fetch(url, options);

    if (response.decentroResponseKey === "NAME_MISMATCHED") {
      this.setState({ showNameMismatchModal: true });
    } else if (!response.verified) {
      this.setState({
        showVerificationFailedModal: true,
        errorMessage: response.message,
        verificationPANLoader: false,
      });
    } else {
      this.setState({
        pan: { maskedPanNumber: this.maskPan(pan), verifiedOn: new Date() },
        showVerificationSuccessModal: true,
        kycOf: "PAN",
        verificationPANLoader: false,
      });
    }
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      message.error("Please upload a valid image file.");
      event.target.value = "";
      return;
    }

    this.setState({
      fileName: file ? file.name : "Choose a file",
      selectedFile: event.target.files[0],
    });
  };

  uploadCheque = () => {
    const { selectedFile } = this.state;
    if (!selectedFile) {
      message.error("Please select a file to upload");
      return;
    }
    this.setState({ showAccountModal: true });
  };

  uploadCancelledCheque = async () => {
    const { selectedFile, accountNumber, ifsc, beneficiaryName } = this.state;
    if (!selectedFile) {
      message.error("Please select a file to upload");
      return;
    }
    if (!accountNumber || !ifsc || !beneficiaryName) {
      message.error("Please enter all the details");
      return;
    }

    if (!accountNumber || !/^\d{9,18}$/.test(accountNumber)) {
      message.error("Please enter a valid account number (9–18 digits).");
      return;
    }

    if (!ifsc || !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.toUpperCase())) {
      message.error("Please enter a valid IFSC code (e.g., HDFC0001234).");
      return;
    }

    if (!beneficiaryName || !/^[A-Za-z\s]{3,50}$/.test(beneficiaryName)) {
      message.error("Please enter a valid beneficiary name (letters only).");
      return;
    }

    const formData = new FormData();
    formData.append("myFile", selectedFile);
    formData.append("accountNumber", accountNumber);
    formData.append("ifscCode", ifsc);
    formData.append("beneficiaryName", beneficiaryName);

    const options = {
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const url = "/cabOperator/uploadCancelledCheque";

    const response = await Fetch(url, options);
    if (Array.isArray(response)) {
      const data = response[0];
      this.setState({
        showAccountModal: false,
        fileName: "File Uploaded",
        selectedFile: null,
        accountNumber: "",
        ifsc: "",
        beneficiaryName: "",
        cancelledChequeDetails:
          data.bankDetails.cancelledChequeStatus || "PENDING",
      });
      message.success("Cancelled cheque uploaded successfully");
    } else {
      this.setState({
        showAccountModal: false,
        accountNumber: "",
        ifsc: "",
        beneficiaryName: "",
      });
      message.error("Failed to upload cancelled cheque. Please try again.");
    }
  };

  requestChange = async () => {
    const url = `/cabOperator/cancelledChequeChange`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response)) {
      this.setState({
        cancelledChequeDetails: "CHANGE_REQUESTED",
        changeRequested: false,
      });
      message.success("Updated");
    }
    return;
  };

  showAadharVerify = async () => {
    const options = {
      method: "post",
    };
    const url = "/cabOperator/aadharOtp";

    const response = await Fetch(url, options);

    if (response.url) {
      window.location.href = response.url;
    }

    return;
  };

  render() {
    const {
      loading,
      fileName,
      isMobile,
      gst,
      pan,
      aadhar,
      showVerificationFailedModal,
      showVerificationSuccessModal,
      showNameMismatchModal,
      cancelledChequeDetails,
      showSideMenu,
      isGSTINRequired = false,
      kycOf = "",
      errorMessage = "Invalid Document. Please use a different one or contact support.",
      verificationPANLoader = false,
      verificationGSTLoader = false,
      changeRequested = false,
      showAccountModal = false,
      accountNumber = "",
      ifsc = "",
      beneficiaryName = "",
    } = this.state;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <div>
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={7}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          <div class="container">
            <div className={less.header}>
              <span>KYC Verification</span>
              <span>
                Complete the KYC verification to continue using the account.
              </span>
            </div>
            <div className={less.gridContainer}>
              <div className={less.verification}>
                <div className={less.heading}>
                  <span>PAN</span>
                  {pan && pan.maskedPanNumber ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Enter PAN number here"
                  className={less.input}
                  value={pan.maskedPanNumber ? pan.maskedPanNumber : pan}
                  disabled={pan.maskedPanNumber}
                  onChange={(e) =>
                    this.handleChange("pan", e.target.value.toUpperCase())
                  }
                />
                {pan && pan.maskedPanNumber ? (
                  <span className={less.verificationNote}>
                    PAN verification was successfully completed on{" "}
                    {moment(pan.verifiedOn).format("LLL")}
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.verifyPAN}>
                      {verificationPANLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify PAN"
                      )}
                    </button>
                  </div>
                )}
              </div>

              <div className={less.verification}>
                <div className={less.heading}>
                  <span>Blank Cheque</span>
                  {cancelledChequeDetails === "APPROVED" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>Change Requested</span>
                    </div>
                  ) : cancelledChequeDetails === "PENDING" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/declined/declined.svg"
                        alt="Rejected"
                      />

                      <span>Rejected</span>
                    </div>
                  )}
                </div>
                <div className="upload-container">
                  <span className="file-label">{fileName}</span>

                  <input
                    type="file"
                    id="file-input"
                    onChange={this.handleFileChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                  {cancelledChequeDetails === "APPROVED" ? null : (
                    <label htmlFor="file-input" className="choose-file">
                      Choose a File
                    </label>
                  )}
                </div>
                {cancelledChequeDetails === "APPROVED" ? (
                  <div className={less.approvedChequeNote}>
                    <span className={less.verificationNote}>
                      Bank details have been mapped to your account
                    </span>
                    <div
                      onClick={() => this.setState({ changeRequested: true })}
                    >
                      <span>Request a Change</span>
                    </div>
                  </div>
                ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                  <span>
                    A change is underway. You can upload the cheque after it
                    gets approved.
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.uploadCheque}>
                      Upload Cheque
                    </button>
                  </div>
                )}
              </div>
              {isGSTINRequired ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>GSTIN</span>
                    {gst.number ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter GSTIN number here"
                    className={less.input}
                    value={gst.number ? gst.number : gst}
                    disabled={gst.number}
                    onChange={(e) =>
                      this.handleChange("gst", e.target.value.toUpperCase())
                    }
                  />
                  {gst && gst.number ? (
                    <span className={less.verificationNote}>
                      GSTIN verification was successfully completed on{" "}
                      {moment(gst.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button className={less.verify} onClick={this.verifyGST}>
                        {verificationGSTLoader ? (
                          <span className={less.loader}></span>
                        ) : (
                          "Verify GSTIN"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>AADHAR</span>
                    {aadhar.maskedAadharNumber ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  {aadhar && aadhar.maskedAadharNumber ? (
                    <input
                      className={less.input}
                      value={aadhar.maskedAadharNumber}
                      disabled={aadhar.maskedAadharNumber}
                    />
                  ) : null}
                  {aadhar && aadhar.maskedAadharNumber ? (
                    <span className={less.verificationNote}>
                      AADHAR verification was successfully completed on{" "}
                      {moment(aadhar.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button
                        className={less.verify}
                        onClick={this.showAadharVerify}
                      >
                        Verify AADHAR
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <Modal
            open={changeRequested}
            closable={false}
            onCancel={() =>
              this.setState({
                changeRequested: false,
              })
            }
            onClose={() =>
              this.setState({
                changeRequested: false,
              })
            }
            footer={null}
          >
            <div className="changeRequestModal">
              <p>Are you sure?</p>
              <span>
                A request will be sent to admin team to change the bank details.
              </span>
              <div onClick={() => this.requestChange()}>
                <span>Raise Request</span>
              </div>
              <div onClick={() => this.setState({ changeRequested: false })}>
                {" "}
                <span>Cancel</span>
              </div>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            onCancel={() => {
              this.setState({ showVerificationFailedModal: false });
            }}
            open={showVerificationFailedModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Verification Failed</p>
              <span>{errorMessage}</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationFailedModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            open={showVerificationSuccessModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/done.svg"
                alt="close"
              />
              <p>Verification Successful</p>
              <span>Your {kycOf} has been successfully verified</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationSuccessModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            open={showNameMismatchModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Name Mismatch</p>
              <span>
                The name on your document doesn't match your account name.
                Please verify and re-enter.
              </span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showNameMismatchModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            onCancel={() =>
              this.setState({
                showAccountModal: false,
                accountNumber: "",
                ifsc: "",
                beneficiaryName: "",
              })
            }
            onClose={() =>
              this.setState({
                showAccountModal: false,
                accountNumber: "",
                ifsc: "",
                beneficiaryName: "",
              })
            }
            footer={null}
            width={500}
            title={null}
            open={showAccountModal}
          >
            <div className={less.chequeModalContent}>
              <p>Enter Cheque Details</p>
              <span>Please enter cheque details to continue.</span>
              <div className={less.inputContainer}>
                <span>Account Number*</span>
                <input
                  type="text"
                  placeholder="Enter account number here"
                  className={less.input}
                  value={accountNumber}
                  onChange={(e) =>
                    this.handleChange("accountNumber", e.target.value)
                  }
                />
              </div>
              <div className={less.inputContainer}>
                <span>IFSC*</span>
                <input
                  type="text"
                  placeholder="Enter IFSC code here"
                  value={ifsc}
                  className={less.input}
                  onChange={(e) => this.handleChange("ifsc", e.target.value)}
                />
              </div>
              <div className={less.inputContainer}>
                <span>Beneficiary Name *</span>
                <input
                  type="text"
                  placeholder="Enter beneficiary name here"
                  className={less.input}
                  value={beneficiaryName}
                  onChange={(e) =>
                    this.handleChange("beneficiaryName", e.target.value)
                  }
                />
              </div>
              <div className={less.buttonContainer}>
                <button
                  onClick={() =>
                    this.setState({
                      showAccountModal: false,
                      fileName: "No file chosen",
                      selectedFile: null,
                      cancelledChequeDetails,
                      accountNumber: "",
                      ifsc: "",
                      beneficiaryName: "",
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  className={less.verify}
                  onClick={() => this.uploadCancelledCheque()}
                >
                  Continue
                </button>
              </div>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={8} isMobile={isMobile} />
          <div class="container">
            <div className={less.header}>
              <span>KYC Verification</span>
              <span>
                Complete the KYC verification to continue using the account.
              </span>
            </div>
            <div className={less.gridContainer}>
              <div className={less.verification}>
                <div className={less.heading}>
                  <span>PAN</span>
                  {pan && pan.maskedPanNumber ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  )}
                </div>
                <input
                  uppr
                  type="text"
                  placeholder="Enter PAN number here"
                  className={less.input}
                  value={pan && pan.maskedPanNumber ? pan.maskedPanNumber : pan}
                  disabled={pan && pan.maskedPanNumber}
                  onChange={(e) =>
                    this.handleChange("pan", e.target.value.toUpperCase())
                  }
                />
                {pan && pan.maskedPanNumber ? (
                  <span className={less.verificationNote}>
                    PAN verification was successfully completed on{" "}
                    {moment(pan.verifiedOn).format("LLL")}
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.verifyPAN}>
                      {verificationPANLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify PAN"
                      )}
                    </button>
                  </div>
                )}
              </div>
              <div className={less.verification}>
                <div className={less.heading}>
                  <span>Blank Cheque</span>
                  {cancelledChequeDetails === "APPROVED" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>Change Requested</span>
                    </div>
                  ) : cancelledChequeDetails === "PENDING" ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/declined/declined.svg"
                        alt="Rejected"
                      />

                      <span>Rejected</span>
                    </div>
                  )}
                </div>
                <div className="upload-container">
                  <span className="file-label">{fileName}</span>

                  <input
                    type="file"
                    id="file-input"
                    onChange={this.handleFileChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                  {cancelledChequeDetails === "APPROVED" ? null : (
                    <label htmlFor="file-input" className="choose-file">
                      Choose a File
                    </label>
                  )}
                </div>
                {cancelledChequeDetails === "APPROVED" ? (
                  <div className={less.approvedChequeNote}>
                    <span className={less.verificationNote}>
                      Bank details have been mapped to your account
                    </span>
                    <div
                      onClick={() => this.setState({ changeRequested: true })}
                    >
                      <span>Request a Change</span>
                    </div>
                  </div>
                ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                  <span>
                    A change is underway. You can upload the cheque after it
                    gets approved.
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.uploadCheque}>
                      Upload Cheque
                    </button>
                  </div>
                )}
              </div>
              {isGSTINRequired ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>GSTIN</span>
                    {gst.number ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter GSTIN number here"
                    className={less.input}
                    value={gst.number ? gst.number : gst}
                    disabled={gst.number}
                    onChange={(e) =>
                      this.handleChange("gst", e.target.value.toUpperCase())
                    }
                  />
                  {gst && gst.number ? (
                    <span className={less.verificationNote}>
                      GSTIN verification was successfully completed on{" "}
                      {moment(gst.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button className={less.verify} onClick={this.verifyGST}>
                        {verificationGSTLoader ? (
                          <span className={less.loader}></span>
                        ) : (
                          "Verify GSTIN"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>AADHAR</span>
                    {aadhar.maskedAadharNumber ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  {aadhar && aadhar.maskedAadharNumber ? (
                    <input
                      className={less.input}
                      value={aadhar.maskedAadharNumber}
                      disabled={aadhar.maskedAadharNumber}
                    />
                  ) : null}

                  {aadhar && aadhar.maskedAadharNumber ? (
                    <span className={less.verificationNote}>
                      AADHAR verification was successfully completed on{" "}
                      {moment(aadhar.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button
                        className={less.verify}
                        onClick={this.showAadharVerify}
                      >
                        Verify AADHAR
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <Modal
            open={changeRequested}
            onCancel={() =>
              this.setState({
                changeRequested: false,
              })
            }
            onClose={() =>
              this.setState({
                changeRequested: false,
              })
            }
            footer={null}
          >
            <div className="changeRequestModal">
              <p>Are you sure?</p>
              <span>
                A request will be sent to admin team to change the bank details.
              </span>
              <div onClick={() => this.requestChange()}>
                <span>Raise Request</span>
              </div>
              <div onClick={() => this.setState({ changeRequested: false })}>
                {" "}
                <span>Cancel</span>
              </div>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            onCancel={() => {
              this.setState({ showVerificationFailedModal: false });
            }}
            open={showVerificationFailedModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Verification Failed</p>
              <span>{errorMessage}</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationFailedModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            open={showVerificationSuccessModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/done.svg"
                alt="close"
              />
              <p>Verification Successful</p>
              <span>Your {kycOf} has been successfully verified</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationSuccessModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={false}
            footer={null}
            title={null}
            open={showNameMismatchModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Name Mismatch</p>
              <span>
                The name on your document doesn't match your account name.
                Please verify and re-enter.
              </span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showNameMismatchModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>

          <Modal
            centered
            onCancel={() =>
              this.setState({
                showAccountModal: false,
                accountNumber: "",
                ifsc: "",
                beneficiaryName: "",
              })
            }
            onClose={() =>
              this.setState({
                showAccountModal: false,
                accountNumber: "",
                ifsc: "",
                beneficiaryName: "",
              })
            }
            footer={null}
            width={500}
            title={null}
            open={showAccountModal}
          >
            <div className={less.chequeModalContent}>
              <p>Enter Cheque Details</p>
              <span>Please enter cheque details to continue.</span>
              <div className={less.inputContainer}>
                <span>Account Number*</span>
                <input
                  type="text"
                  placeholder="Enter account number here"
                  className={less.input}
                  value={accountNumber}
                  onChange={(e) =>
                    this.handleChange("accountNumber", e.target.value)
                  }
                />
              </div>
              <div className={less.inputContainer}>
                <span>IFSC*</span>
                <input
                  type="text"
                  placeholder="Enter IFSC code here"
                  className={less.input}
                  value={ifsc}
                  onChange={(e) => this.handleChange("ifsc", e.target.value)}
                />
              </div>
              <div className={less.inputContainer}>
                <span>Beneficiary Name *</span>
                <input
                  type="text"
                  placeholder="Enter beneficiary name here"
                  className={less.input}
                  value={beneficiaryName}
                  onChange={(e) =>
                    this.handleChange("beneficiaryName", e.target.value)
                  }
                />
              </div>
              <div className={less.buttonContainer}>
                <button
                  onClick={() =>
                    this.setState({
                      showAccountModal: false,
                      fileName: "No file chosen",
                      selectedFile: null,
                      cancelledChequeDetails,
                      accountNumber: "",
                      ifsc: "",
                      beneficiaryName: "",
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  className={less.verify}
                  onClick={() => this.uploadCancelledCheque()}
                >
                  Continue
                </button>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default kycCabOperator;
